<template>
  <div>
    <b-row class="mb-3">
      <b-col>
        <label>Level</label>
        <br />
        <b-form-select v-model="classroom.level_id" :options="levelOption" @change="changeClass()"></b-form-select>
      </b-col>
      <b-col>
        <label>Class</label>
        <br />
        <b-form-select v-model="classroom.class_id" :options="classOption"></b-form-select>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <label>Name</label>
        <br />
        <b-form-input v-model="classroom.name" placeholder="Enter name..."></b-form-input>
      </b-col>
      <b-col>
        <label>Status</label>
        <br />
        <b-form-checkbox v-model="classroom.status" name="check-button" switch>
          <b-badge variant="success" v-if="classroom.status">Publish</b-badge>
          <b-badge variant="secondary" v-else>Unpublish</b-badge>
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row class="mb-5">
      <b-col class="justify-end">
        <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading" 
            @click="handleSave"
          >
            SAVE
          </my-button>
      </b-col>
    </b-row>

    <div class="mb-5">
      <hr>
      <div class="space-between align-center mb-3">
        <h3>Teacher List</h3>
        <button type="button" class="btn mulai btn-secondary font-bold" @click="handleUploadTeacher">
          <fa-icon icon="upload" class="my-icon" />&nbsp; UPLOAD TEACHER
        </button>
      </div>
      <b-table striped :items="classroom.subject" :fields="fieldSubject" show-empty>
        <template #cell(teacher)="row">
          <ul>
            <li v-for="(item, index) in row.item.teacher">
              {{ item.name }} 
              &nbsp;&nbsp;
              <b-badge 
                pill variant="danger" 
                @click="handleDeleteTeacher(item)"
                style="cursor: pointer;"
              >
                <fa-icon icon="minus-circle" class="my-icon" />
              </b-badge>
            </li>
          </ul>
        </template>
        <template #cell(actions)="row">
          <b-button
            size="sm"
            class="mr-3 action-button"
            variant="outline-danger"
            @click="handleDeleteSubject(row.item)"
          >
            <fa-icon icon="minus-circle" class="my-icon" />&nbsp;Delete
          </b-button>
        </template>
      </b-table>
    </div>

    <div class="mb-5">
      <hr>
      <div class="space-between align-center mb-3">
        <h3>Student List</h3>
        <button type="button" class="btn mulai btn-secondary font-bold" @click="handleUploadStudent">
          <fa-icon icon="upload" class="my-icon" />&nbsp; UPLOAD STUDENT
        </button>
      </div>
      <b-table striped :items="classroom.student" :fields="fieldStudent" show-empty>
        <template #cell(actions)="row">
          <b-button
            size="sm"
            class="mr-3 action-button"
            variant="outline-danger"
            @click="handleDeleteStudent(row.item)"
          >
            <fa-icon icon="minus-circle" class="my-icon" />&nbsp;Delete
          </b-button>
        </template>
      </b-table>
    </div>

    <b-modal
      v-model="uploadModal"
      id="uploadModal"
      hide-header
      hide-footer
      centered
      size="lg"
    >
      <modal-cross @close="uploadModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">{{uploadTeacher ? "Upload Teacher" : "Upload Student"}}</h3>
        <br />

        <p>
          Template 
          <a href="/file/template_teacher.xlsx" target="_blank" v-if="uploadTeacher">template_teacher.xlsx</a>
          <a href="/file/template_student.xlsx" target="_blank" v-else>template_student.xlsx</a>
        </p>
        <label class="mt-4">File</label>
        <div class="upload-image">
          <div class="upload-image__item mr-4">
            <div class="upload-image__top" v-show="uploadFilename">
              <div class="align-center">
                <strong class="color7 mr-1">
                  <fa-icon icon="file-pdf"></fa-icon>
                </strong>
                <strong>{{uploadFilename}}</strong>
              </div>
            </div>

            <div class="upload-image__bottom">
              <input type="file" name="file1" id="file1" class="hidden-input" @change="changeFile" />
              <label for="file1" class="file-upload">
                <fa-icon icon="upload" class="my-icon" />
                Upload File
              </label>
            </div>
          </div>
        </div>

        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoadingUpload"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoadingUpload"
            @click="handleUpload"
          >
            SAVE
          </my-button>
        </div>
        <br />
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      levelOption:[{value: '', text: "All"}],
      classOption:[{value: '', text: "All"}],
      classroom: {
        name: '', 
        class_id: '', 
        level_id: '', 
        status: '', 
        subject: [], 
        student: []
      }, 
      fieldSubject: [
        {
          key: "subject_id",
          label: "#ID", 
          sortable: true,
          sortDirection: "asc"
        },
        {
          key: "name",
          label: "Subject Name",
          sortable: true
        },
        {
          key: "teacher",
          label: "Teacher",
          sortable: true
        },
        {
          key: "actions",
          label: "Action"
        }
      ],
      fieldStudent: [
        {
          key: "student_id",
          label: "#ID", 
          sortable: true,
          sortDirection: "asc"
        },
        {
          key: "name",
          label: "Student Name",
          sortable: true
        },
        {
          key: "nis",
          label: "NIS",
          sortable: true
        },
        {
          key: "mailing_email",
          label: "Email",
          sortable: true
        },
        {
          key: "actions",
          label: "Action"
        }
      ],
      showLoading: false,
      showLoadingUpload: false,
      uploadModal: false,
      uploadTeacher: false,
      uploadFile: null,
      uploadFilename: null
    }
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn"
    })
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.push("/login");
    }
  },
  mounted() {
    this.getDetail()
    this.levelList()
  },
  methods: {
    ...mapActions({
      getLevelList: types.GET_LEVEL_LIST,
      getClassList: types.GET_CLASS_LIST,
      classroomDetail: types.CLASSROOM_DETAIL, 
      classroomUpdate: types.CLASSROOM_UPDATE,
      classroomTeacherUpload: types.CLASSROOM_TEACHER_UPLOAD,
      classroomStudentUpload: types.CLASSROOM_STUDENT_UPLOAD,
      classroomSubjectUnassign: types.CLASSROOM_SUBJECT_UNASSIGN,
      classroomTeacherUnassign: types.CLASSROOM_TEACHER_UNASSIGN,
      classroomStudentUnassign: types.CLASSROOM_STUDENT_UNASSIGN
    }),
    levelList() {
      this.levelOption = [{value: '', text: "All"}];

      this.getLevelList()
      .then(response => {
        for (var i = 0; i < response.length; i++) {
          this.levelOption.push({
            value: response[i].id, 
            text: response[i].name
          });
        }
      })
      .catch(error => {
        this.showMessageBox(error, "Failed", "success");
      });
    },
    changeClass() {
      this.classroom.class_id = ''
      this.classList()
    },
    classList() {
      this.classOption = [{value: '', text: "All"}];

      if(this.classroom.level_id) {
        var payload = {
          params: {
            order: 'code', 
            level: this.classroom.level_id
          }
        }
        this.getClassList(payload)
        .then(response => {
          for (var i = 0; i < response.length; i++) {
            this.classOption.push({
              value: response[i].id, 
              text: response[i].name
            });
          }
        })
        .catch(error => {
          this.showMessageBox(error, "Failed", "success");
        });
      }
    },
    getDetail() {
      var payload = {
        params: {
          id: this.$route.params.id
        } 
      }

      this.classroomDetail(payload)
      .then(response => {
        response.status = response.status ? true : false;
        var subject = [];
        for(var key in response.subject) {
          subject.push(response.subject[key]);
        }
        this.classroom = response;
        this.classroom.subject = subject;
        this.classList()
      })
      .catch(error => {
        this.showMessageBox(error, "Failed", "success");
      });
    },
    handleSave() {
      if(this.classroom.name && this.classroom.class_id) {
        this.updateClassroom();
      } else {
        this.showMessageBox('Please input all data', 'Empty Data', 'danger')
      }
    },
    updateClassroom() {
      this.showLoading = true

      var payload = { 
        id:this.classroom.id, 
        name: this.classroom.name, 
        class_id: this.classroom.class_id, 
        status: this.classroom.status ? 1:0
      }

      this.classroomUpdate(payload)
      .then(response => {
        this.showLoading = false
        this.showMessageBox("Data has been updated", "Success", "success");
      })
      .catch(error => {
        this.showLoading = false
        this.showMessageBox(error, "Failed", "success");
      });
    },
    handleUploadTeacher() {
      this.uploadTeacher = true;
      this.uploadModal = true;
    },
    handleUploadStudent() {
      this.uploadTeacher = false;
      this.uploadModal = true;
    },
    changeFile() {
      var fileData = event.target.files[0];
      this.uploadFile = fileData;
      this.uploadFilename = fileData.name;
    },
    handleUpload() {
      if(this.uploadFile) {
        this.showLoadingUpload = true;

        let newFormData = new FormData();
        newFormData.append("classroom_id", this.classroom.id);
        newFormData.append("file", this.uploadFile);

        if(this.uploadTeacher) {
          this.classroomTeacherUpload(newFormData)
          .then(response => {
            this.showLoadingUpload = false
            this.uploadModal = false
            this.getDetail()
            this.showMessageBox("Data has been saved", "Success", "success");
          })
          .catch(error => {
            this.showLoadingUpload = false
            this.showMessageBox(error, "Failed", "success");
          });
        } else {
          this.classroomStudentUpload(newFormData)
          .then(response => {
            this.showLoadingUpload = false
            this.uploadModal = false
            this.getDetail()
            this.showMessageBox("Data has been saved", "Success", "success");
          })
          .catch(error => {
            this.showLoadingUpload = false
            this.showMessageBox(error, "Failed", "success");
          });
        }
      } else {
        this.showMessageBox("Please select file first", "Empty Data", "warning");
      }
    },
    handleDeleteSubject(item) {
      this.$bvModal.msgBoxConfirm('Delete this subject ' + item.name + ' ?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value) {
            var payload = {
              classroom_id: this.classroom.id,
              subject_id: "" + item.subject_id
            }

            this.classroomSubjectUnassign(payload)
            .then(response => {
              this.getDetail()
              this.showMessageBox("Data has been deleted", "Success", "success");
            })
            .catch(error => {
              this.showLoading = false;
              this.showMessageBox(error, "Failed", "danger");
            });
          }
        })
        .catch(err => {
          this.showMessageBox(err, "Failed", "danger");
        });
    },
    handleDeleteTeacher(item) {
      this.$bvModal.msgBoxConfirm('Delete this teacher ' + item.name + ' ?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value) {
            var payload = {
              classroom_id: this.classroom.id,
              subject_id: item.subject_id,
              teacher_id: item.teacher_id
            }

            this.classroomTeacherUnassign(payload)
            .then(response => {
              this.getDetail()
              this.showMessageBox("Data has been deleted", "Success", "success");
            })
            .catch(error => {
              this.showLoading = false;
              this.showMessageBox(error, "Failed", "danger");
            });
          }
        })
        .catch(err => {
          this.showMessageBox(err, "Failed", "danger");
        });
    },
    handleDeleteStudent(item) {
      this.$bvModal.msgBoxConfirm('Delete this student ' + item.name + ' ?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value) {
            var payload = {
              classroom_id: this.classroom.id,
              student_id: "" + item.student_id
            }

            this.classroomStudentUnassign(payload)
            .then(response => {
              this.getDetail()
              this.showMessageBox("Data has been deleted", "Success", "success");
            })
            .catch(error => {
              this.showLoading = false;
              this.showMessageBox(error, "Failed", "danger");
            });
          }
        })
        .catch(err => {
          this.showMessageBox(err, "Failed", "danger");
        });
    },
    showMessageBox(message, title, variant) {
      this.$bvModal
      .msgBoxOk(message, {
        title: title,
        size: "sm",
        buttonSize: "sm",
        okVariant: variant,
        centered: true
      })
      .then(value => {
      })
      .catch(err => {
      });
    }
  }
};
</script>

<style>
.search-wrapper {
  width: 100%;
  max-width: 222px;
}

.filter-icon {
  margin-right: 11px;
  background-color: #e9e9e9;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  text-align: center;
  padding-top: 7px;
}

.action-button:hover {
  background-color: #f08045;
  border: 1px solid #f08045;
}
</style>